import { cn } from "@omni/utils/styles";

import { Collapse } from "@/components/General/Collapse/collapse.component";
import { useAccordionItemContext } from "@/components/General/Faq/context/accordionItem.context";

type Props = { className?: string };

export const Answer = ({ className }: Props) => {
    const { question, open } = useAccordionItemContext();

    return (
        <Collapse
            isOpen={open}
            className={cn(className)}
        >
            <div
                dangerouslySetInnerHTML={{
                    __html: question.answer
                }}
            />
        </Collapse>
    );
};
